import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { SaveToteTransactionPayload, ToteTransactionByIdRecord, ToteTransactionFeeResponse, ToteTransactionRecord } from '../interfaces/tote-transaction-record';
import { IdName } from '../interfaces/pricematrixmodel';

@Injectable({
    providedIn: 'root'
})
export class ToteTransactionService {
    baseUrl = environment.baseUrl;
    constructor(private http: HttpClient) { }
    getToteTransactions(customerId: number | null, startDate: any, endDate: any): Observable<ToteTransactionRecord[]> {
        var params = new URLSearchParams();
        if (customerId != null)
            params.append('CustomerID', customerId.toString());
        params.append('StartDate', startDate);
        params.append('EndDate', endDate);
        var url = `${this.baseUrl}totetransactions?${params.toString()}`;
        return this.http.get<ToteTransactionRecord[]>(url);
    }
    getToteTransactionById(id: number): Observable<ToteTransactionByIdRecord> {
        var url = `${this.baseUrl}totetransactions/${id}`;
        return this.http.get<ToteTransactionByIdRecord>(url);
    }
    getToteTransactionTypes(): Observable<IdName[]> {
        var url = `${this.baseUrl}totetransactions/GetToteTransactionType`;
        return this.http.get<IdName[]>(url);
    }
    getToteTransactionStatuses(): Observable<IdName[]> {
        var url = `${this.baseUrl}totetransactions/GetToteTransactionStatus`;
        return this.http.get<IdName[]>(url);
    }
    saveToteCustomerTransaction(payload: SaveToteTransactionPayload): Observable<boolean> {
        var url = `${this.baseUrl}totetransactions/SaveToteCustomerTransaction`;
        return this.http.post<boolean>(url, payload);
    }
    getFee(transactionTypeID: number, generatorId: number, streamId: number, txDate: string): Observable<ToteTransactionFeeResponse> {
        var params = new URLSearchParams();
        params.append('TransactionTypeID', transactionTypeID.toString());
        params.append('GeneratorId', generatorId.toString());
        params.append('StreamId', streamId.toString());
        params.append('Date', txDate);
        var url = `${this.baseUrl}totetransactions/GetTransactionFeeFromPriceMatrix?${params.toString()}`;
        return this.http.get<ToteTransactionFeeResponse>(url);
    }
    deleteRecordById(id: number): Observable<boolean> {
        var url = `${this.baseUrl}totetransactions/${id}`;
        return this.http.delete<boolean>(url);
    }
}